import { getAllVouchers } from './getAllVouchers'

export const useFilteredVoucherListByCountry = <T>(
  denominationsByCountry: Record<string, T[]>,
  country: string | null
) => {
  if (!country) return getAllVouchers(denominationsByCountry)

  return denominationsByCountry[country]
}
